// extracted by mini-css-extract-plugin
export default {"add":"control_add__WrcdK","tooltip":"control_tooltip__9x48B"};